module.exports = __webpack_public_path__ + "img/model_63_zh.ab9ab2ed.jpg";